import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const Delay = 5000;

@Component({
    selector: 'ell-confirm-submission',
    standalone: true,
    imports: [FontAwesomeModule],
    templateUrl: './confirm-submission.component.html',
    styleUrl: './confirm-submission.component.scss'
})
export class ConfirmSubmissionComponent implements OnDestroy {
    private delay?: ReturnType<typeof setTimeout>;

    faPaperPlane = faPaperPlane;
    showAbort = false;

    @Output()
    countingDown = new EventEmitter<boolean>();

    @Output()
    submit = new EventEmitter<void>();

    startCountdown() {
        this.showAbort = true;
        this.countingDown.emit(true);
        this.delay = setTimeout(
            () => { this.submit.emit() },
            Delay);
    }

    cancel() {
        clearTimeout(this.delay);
        this.showAbort = false;
        this.countingDown.emit(false);
    }

    ngOnDestroy(): void {
        this.cancel();
    }
}
